import React from 'react';
import { Outlet } from 'react-router-dom';
import AccessDeniedCard from '../../../components/AccessDeniedCard';
import { usePermissions } from '../../../hooks/usePermissions';
import { useRoleModuleLabel } from '../../../hooks/useRoleModuleLabel';
import {
  READ_BULK_UPLOAD,
  READ_CUSTOMER,
  READ_PRODUCT,
  READ_PURCHASE_INVOICE,
  READ_PURCHASE_REGISTER,
  READ_SALE_CREDIT_NOTE,
  READ_SALE_INVOICE,
  READ_SALE_REGISTER,
  READ_SUPPLIER,
} from '../../../constants/eInvoicePermissions';
import { BULK_UPLOAD_MODULE_KEY } from '../../settings/constants/roleModules';

export default function BulkUploadAcessLayout() {
  const { loading, hasEInvoicePermission } = usePermissions();
  const title = useRoleModuleLabel(BULK_UPLOAD_MODULE_KEY);

  if (loading) {
    return null;
  }

  const canReadSales = hasEInvoicePermission(READ_SALE_INVOICE) || hasEInvoicePermission(READ_SALE_CREDIT_NOTE);

  const canReadPurchases = hasEInvoicePermission(READ_PURCHASE_INVOICE);

  const canReadSalesRegister = hasEInvoicePermission(READ_SALE_REGISTER);

  const canReadPurchaseRegister = hasEInvoicePermission(READ_PURCHASE_REGISTER);

  const canReadCustomer = hasEInvoicePermission(READ_CUSTOMER);

  const canReadProduct = hasEInvoicePermission(READ_PRODUCT);

  const canReadSupplier = hasEInvoicePermission(READ_SUPPLIER);

  const hasResourceReadPermission =
    canReadSales ||
    canReadPurchases ||
    canReadSalesRegister ||
    canReadPurchaseRegister ||
    canReadCustomer ||
    canReadProduct ||
    canReadSupplier;

  const isAllowed = hasEInvoicePermission(READ_BULK_UPLOAD) && hasResourceReadPermission;

  if (!isAllowed) {
    return <AccessDeniedCard title={title} />;
  }

  return <Outlet />;
}
